import { Component } from '@angular/core';

@Component({
    selector: 'app-no-data-found',
    imports: [],
    templateUrl: './no-data-found.component.html',
    styleUrl: './no-data-found.component.scss'
})
export class NoDataFoundComponent {

}
